<div class="flex flex-col h-screen w-full">
  <app-page-header>
    <div class="flex flex-row justify-start items-center gap-2 h-10">
      <span>Benutzerkonto</span>
    </div>
  </app-page-header>

  @if (isInit) {
    <div class="flex-1 w-full overflow-y-auto p-6 min-h-0">

      <bic-accordion [gapBetweenElements]="0" [openedIndex]=0 [disableManualToggle]="!validForm()" #accordion>
        <bic-accordion-element>
          <bic-accordion-header>
            <div>1. Profil</div>
          </bic-accordion-header>
          <bic-accordion-body>
            @if (registerForm) {<ng-container *ngTemplateOutlet="registerData"></ng-container>}
          </bic-accordion-body>
        </bic-accordion-element>

        <bic-accordion-element>
          <bic-accordion-header [style.pointer-events]="validForm() ? 'auto' : 'none'" [style.opacity]="validForm() ? '1' : '0.5'">
            <div>2. Adresse</div>
          </bic-accordion-header>
          <bic-accordion-body>
            @if (registerForm) {<ng-container *ngTemplateOutlet="addressInfo"></ng-container>}
          </bic-accordion-body>
        </bic-accordion-element>

        <bic-accordion-element>
          <bic-accordion-header [style.pointer-events]="validForm() ? 'auto' : 'none'" [style.opacity]="validForm() ? '1' : '0.5'">
            <div>3. Kontosicherheit (Empfohlen)</div>
          </bic-accordion-header>
          <bic-accordion-body>
            <ng-container *ngTemplateOutlet="twoFaData"></ng-container>
          </bic-accordion-body>
        </bic-accordion-element>
      </bic-accordion>
    </div>
  }

  @if (user && !isInit) {
    <div class="flex-1 w-full overflow-y-auto p-6 min-h-0">
      <bic-accordion [gapBetweenElements]="0" [openedIndex]=0 #accordion>
        <bic-accordion-element>
          <bic-accordion-header>
            <div>1. Profil</div>
          </bic-accordion-header>
          <bic-accordion-body>
            @if (registerForm) {<ng-container *ngTemplateOutlet="registerData"></ng-container>}
          </bic-accordion-body>
        </bic-accordion-element>

        <bic-accordion-element>
          <bic-accordion-header>
            <div>2. Adresse</div>
          </bic-accordion-header>
          <bic-accordion-body>
            @if (registerForm) {<ng-container *ngTemplateOutlet="addressInfo"></ng-container>}
          </bic-accordion-body>
        </bic-accordion-element>

        <bic-accordion-element>
          <bic-accordion-header>
            <div>3. Organisationen</div>
          </bic-accordion-header>
          <bic-accordion-body>
            @if (registerForm) {<app-organisationList [user]="user"></app-organisationList>}
          </bic-accordion-body>
        </bic-accordion-element>

        <bic-accordion-element>
          <bic-accordion-header>
            <div>4. Projekte</div>
          </bic-accordion-header>
          <bic-accordion-body>
            @if (registerForm) {<app-user-projects [user]="user"></app-user-projects>}
          </bic-accordion-body>
        </bic-accordion-element>

        <bic-accordion-element>
          <bic-accordion-header>
            <div>5. Konto und Sicherheit</div>
          </bic-accordion-header>
          <bic-accordion-body>
            <ng-container *ngTemplateOutlet="twoFaData"></ng-container>
            <div class="flex flex-row w-full border border-gray-100 my-6"></div>
            <ng-container *ngTemplateOutlet="changePasswordData"></ng-container>
          </bic-accordion-body>
        </bic-accordion-element>
      </bic-accordion>
    </div>
  }
</div>

<ng-template #registerData>
  <form [formGroup]="registerForm">
    <div class="flex flex-col gap-5">
      <div class="flex flex-row justify-between pt-2 gap-8">
        <app-profile-image-upload [(image)]="user.profileImage"></app-profile-image-upload>
        <!-- min-w-0: ein Flex-Element hat standardmaessig min-width:auto und weigert sich, unter
             die Mindestbreite seines Inhalts zu schrumpfen. Ohne das kann das Raster darin trotz
             korrekter Spaltendefinition nicht enger werden. -->
        <div class="profile-field-rows flex flex-col justify-between w-full min-w-0 gap-5">
          <div class="profile-field-grid">

            <bic-select formControlName="salutation" [label]="'Anrede *'" [required]="true" [placeholder]="'Anrede auswählen'">
              <bic-dropdown-element [value]="salutation.HERR">Herr</bic-dropdown-element>
              <bic-dropdown-element [value]="salutation.FRAU">Frau</bic-dropdown-element>
              <bic-dropdown-element [value]="salutation.NONE">Keine</bic-dropdown-element>
            </bic-select>

            <bic-select formControlName="title" [label]="'Titel'" [required]="false" [placeholder]="'Title auswählen'">
              <bic-dropdown-element [value]="title.NONE">Kein Titel</bic-dropdown-element>
              <bic-dropdown-element [value]="title.DR">Dr.</bic-dropdown-element>
              <bic-dropdown-element [value]="title.PROF">Prof.</bic-dropdown-element>
              <bic-dropdown-element [value]="title.PROFDR">Prof. Dr.</bic-dropdown-element>
            </bic-select>

            <bic-input
              [errorCondition]="registerForm.controls.firstName.touched && registerForm.controls.firstName.invalid"
              [label]="'Vorname *'" [required]="true" [placeholder]="'Vorname eingeben'" [showX]="false"
              formControlName="firstName"></bic-input>

            <bic-input
              [errorCondition]="registerForm.controls.lastName.touched && registerForm.controls.lastName.invalid"
              [label]="'Nachname *'" [required]="true" [placeholder]="'Nachname eingeben'" [showX]="false"
              formControlName="lastName"></bic-input>
          </div>

          <div class="profile-field-grid">
            <bic-input formControlName="mail" [label]="'Mail'" [disabled]="true" [placeholder]="'E-Mail eingeben'" [showX]="false" ></bic-input>

            <bic-input [errorCondition]="(registerForm.get('phoneNumber')?.touched && registerForm.get('phoneNumber')?.invalid) || false"
                       [label]="'Telefon'"
                       [placeholder]="'Telefonnummer eingeben'" [required]="false" [showX]="false"
                       formControlName="phoneNumber"></bic-input>

            <bic-input [iconStart]="faCalendarDays" [isDatepicker]="true" [label]="'Geburtstag'" [minDateToday]="false"
                       [required]="false" [placeholder]="'Datum auswählen'" [showX]="false"
                       bicDatepickerInput formControlName="birthdate"
                       (dateChange)="registerForm.get('birthdate')?.setValue($event)"></bic-input>

            <bic-select formControlName="branch" [label]="'Branche'" [required]="false" [placeholder]="'Branche auswählen'">
              @for (b of branch | keyvalue; track b) {
                <bic-dropdown-element [value]="b.value">{{ b.value | branch }}</bic-dropdown-element>
              }
            </bic-select>
          </div>
        </div>

      </div>
      <div class="flex flex-row justify-end items-center">
        @if (isInit) {
          <bic-button (onClick)="save()"
                      [disabled]="!registerForm.valid">Weiter
          </bic-button>
        }
        @if (!isInit) {
          <bic-button (onClick)="save()" [disabled]="!registerForm.dirty && !isInit">
            Speichern
          </bic-button>
        }
      </div>
    </div>


  </form>
</ng-template>


<ng-template #addressInfo>
  @if (addressInfoForm) {
    <app-address-input [formGroup]="addressInfoForm"></app-address-input>
  }

  <div class="flex flex-row justify-end items-center gap-2 pt-5">
    @if (isInit) {
      <bic-button (onClick)="saveAddress()"
                  [disabled]="!addressInfoForm.valid">Weiter
      </bic-button>
    }
    @if (!isInit) {
      <bic-button (onClick)="saveAddress()" [disabled]="!addressInfoForm.dirty && !isInit">
        Speichern
      </bic-button>
    }
  </div>

</ng-template>

<ng-template #twoFaData>
  <div class="flex flex-col w-full">
    <div class="flex flex-row w-full pb-5 items-center">
      <span class="text-sm font-medium text-gray-900">Zwei-Faktor-Authentifizierung</span>
      <!--      <fa-icon [icon]="faCircleInfo" class="text-[#D1D5DB] text-sm" tooltip="Die Zwei-Faktor-Authentifizierung (2FA) bietet eine zusätzliche Sicherheitsebene für Ihre Anmeldung. Neben Ihrem Passwort benötigen Sie einen zweiten Bestätigungsschritt, z.B. einen Code aus einer Authentifizierungs-App. Diese Methode schützt Ihr Konto vor unbefugtem Zugriff, selbst wenn Ihr Passwort gestohlen wird."></fa-icon>-->
    </div>
    <div class="flex flex-row w-full justify-between pb-5">
      <div class="flex flex-col">
        <span class="text-sm font-medium text-gray-900">E-Mail</span>
        <span class="text-sm font-normal text-gray-500">Verwende deine E-Mail Adresse um den Bestätigungscode zu empfangen.</span>
      </div>
      <label class="inline-flex items-center cursor-pointer gap-3">
        <span class="text-sm font-normal text-gray-900">Nein</span>
        <input type="checkbox" [checked]="tfaMail" class="sr-only peer" id="tfaMail" (change)="handleChange($event)">
        <div
          class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer dark:bg-gray-400 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green"></div>
        <span class="text-sm font-normal text-gray-900">Ja</span>
      </label>
    </div>
    <div class="flex flex-row w-full justify-between">
      <div class="flex flex-col">
        <span class="text-sm font-medium text-gray-900">Authentifizierungs-App</span>
        <span
          class="text-sm font-normal text-gray-500">Verwende eine Authentifizierungs-App um den Bestätigungscode zu empfangen.</span>
      </div>
      <label class="inline-flex items-center cursor-pointer gap-3">
        <span class="text-sm font-normal text-gray-900">Nein</span>
        <input type="checkbox" [checked]="tfaApp" class="sr-only peer" id="tfaApp" (change)="handleChange($event)">
        <div
          class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer dark:bg-gray-400 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green"></div>
        <span class="text-sm font-normal text-gray-900">Ja</span>
      </label>


    </div>

  </div>
  @if (isInit) {
    <div class="flex flex-row justify-end items-center pt-5">
      <bic-button [routerLink]="['/organisations']"
                  [disabled]="!registerForm.valid || !addressInfoForm.valid">
        Erstellen <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
      </bic-button>
    </div>
  }

</ng-template>

<ng-template #changePasswordData>
  <ng-container>
    <form [formGroup]="passwordForm">
      <div class="flex flex-col w-full gap-6">
        <div class="flex flex-row w-full items-center gap-1.5">
          <span class="text-sm font-medium text-gray-900">Passwort ändern</span>
        </div>
        <div class="flex flex-row w-full gap-8">
          <bic-input class="w-1/2" formControlName="currentPassword" [label]="'Altes Passwort *'" [isPassword]="true" [placeholder]="'Altes Passwort eingeben'"
                     [required]="true"
                     [errorCondition]="passwordForm.controls.currentPassword.touched && passwordForm.controls.currentPassword.invalid"
                     (blur)="passwordForm.get('currentPassword')?.markAsTouched()"
                     (focus)="passwordForm.get('currentPassword')?.markAsUntouched()"
                     [(showPassword)]="showPasswordOld"></bic-input>
          <div class="w-1/2"></div>
        </div>
        <div class="flex flex-row w-full gap-8">
          <div class="flex flex-col w-1/2">
            <bic-input class="w-full " formControlName="newPassword" [label]="'Neues Passwort *'" [isPassword]="true" [placeholder]="'Neues Passwort eingeben'"
                       [required]="true"
                       [errorCondition]="passwordForm.controls.newPassword.touched && passwordForm.controls.newPassword.invalid"
                       (blur)="passwordForm.get('newPassword')?.markAsTouched()"
                       (focus)="passwordForm.get('newPassword')?.markAsUntouched()"
                       [(showPassword)]="showPasswordNew"></bic-input>
            @if (passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid) {
              @if (!passwordForm.get('newPassword')?.errors?.required) {
                @if (!passwordForm.get('newPassword')?.valid) {
                  <span class="text-xs text-red pt-1">Das Passwort entspricht nicht den Sicherheitsvorgaben.</span>
                }
              }
            }
          </div>

          <div class="flex flex-col w-1/2">
            <bic-input class="w-full" formControlName="newPasswordRepeat" [label]="'Neues Passwort wiederholen *'" [placeholder]="'Neues Passwort wiederholen'"
                       [isPassword]="true" [required]="true"
                       [errorCondition]="passwordForm.controls.newPasswordRepeat.touched && passwordForm.controls.newPasswordRepeat.invalid"
                       (blur)="passwordForm.get('newPasswordRepeat')?.markAsTouched()"
                       (focus)="passwordForm.get('newPasswordRepeat')?.markAsUntouched()"
                       [(showPassword)]="showPasswordNewRepeat"></bic-input>
            @if (passwordForm.get('newPasswordRepeat')?.touched && passwordForm.get('newPasswordRepeat')?.invalid) {
              @if (passwordForm.get('newPasswordRepeat')?.errors?.matchValue != null) {
                @if (!passwordForm.get('newPasswordRepeat')?.errors?.matchValue && (passwordForm.get('newPassword')?.value != '' || passwordForm.get('newPasswordRepeat')?.value != '')) {
                  <span class="text-xs text-red pt-1">Die Passwörter stimmen nicht überein.</span>
                }
              }
            }
          </div>
        </div>

      </div>
    </form>

    <div class="flex flex-col justify-start items-start w-full mt-4">
      <span class="text-sm font-medium text-gray-900 pb-1">Vorgaben Passwortsicherheit</span>
      <div class="flex flex-row items-center pl-4">
        <ul class="text-gray text-xs list-disc ">
          <li [class]=" testLength(passwordForm.get('newPassword')?.value ?? '') ? 'text-xs font-normal text-green' : 'text-xs font-normal text-gray-900'">
            Enthält mindestens 8 Zeichen
          </li>
          <li
            [class]=" testUpperCase(passwordForm.get('newPassword')?.value ?? '') && testLowerCase(passwordForm.get('newPassword')?.value ?? '') ? 'text-xs font-normal text-green' : 'text-xs font-normal text-gray-900'">
            Ein Groß- und Kleinbuchstabe
          </li>
          <li [class]=" testNumeric(passwordForm.get('newPassword')?.value ?? '') ? 'text-xs font-normal text-green' : 'text-xs font-normal text-gray-900'">
            Eine Zahl
          </li>
          <li
            [class]=" testSpecialCharacter(passwordForm.get('newPassword')?.value ?? '') ? 'text-xs font-normal text-green' : 'text-xs font-normal text-gray-900'">
            Ein Sonderzeichen (!\?&%=.\-:*#&#64;$)
          </li>
        </ul>
      </div>
    </div>
    <div class="flex flex-row justify-end items-center gap-4 pt-5">
      <bic-button (onClick)="openDeleteDialog()" buttonType="white">Konto löschen
      </bic-button>
      <bic-button (onClick)="renewPassword()" [disabled]="!passwordForm.valid || !passwordForm.dirty">Speichern
      </bic-button>
    </div>
  </ng-container>

</ng-template>
